export interface IValidation {
    firstName: boolean,
    lastName: boolean,
    email: boolean,
    positions: boolean,
    phoneMumbers: boolean
}

export const initialValidation: IValidation = {
    firstName: true,
    lastName: true,
    email: true,
    positions: true,
    phoneMumbers: true
}